import styled from 'styled-components';

const Wrapper = styled.div<{ img: string }>`
  position: relative;
  overflow: hidden;
  opacity: 0.99;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -100;
    left: 0;
    transition: opacity 0.5s ease 500ms;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
    background-image: ${({ img }) => `url(${img})`};
  }
`;

export { Wrapper };
